<template>
  <div class="app-seg" :class="{ 'app-seg--disabled': disabled }" role="group" :aria-label="label">
    <button
      v-for="(item, i) in entries"
      :key="i"
      type="button"
      class="app-seg__btn"
      :aria-pressed="isSelected(item) ? 'true' : 'false'"
      :disabled="disabled || item.disabled"
      @click="select(item)"
    >{{ item.text }}</button>
  </div>
</template>

<script>
// Segment-Steuerung (Spezifikation 2.6): Spur #eef0f3, gewähltes Segment weiß mit weicher Kante --edge, Schatten --sh-ctl und 600.
// items: [{ value, text }]; label = aria-label der Gruppe (z. B. „Status“). Ereignis input (Wert).
export default {
  name: 'AppSegment',
  props: {
    value: { type: null, default: null },
    items: { type: Array, default: () => [] },
    label: { type: String, default: null },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    entries() {
      return this.items.map(item => (item !== null && typeof item === 'object' ? item : { value: item, text: String(item) }));
    }
  },
  methods: {
    isSelected(item) {
      return item.value === this.value;
    },
    select(item) {
      if (!this.isSelected(item)) {
        this.$emit('input', item.value);
      }
    }
  }
};
</script>
